import type { Series } from "utils/charts/types";

export const SERIES_9: Series[] = [
    { key: "LH_X", name: "LH X", color: "#4E79A7" },
    { key: "LH_Y", name: "LH Y", color: "#F28E2B" },
    { key: "LH_Z", name: "LH Z", color: "#E15759" },
    { key: "LWT_X", name: "LWT X", color: "#76B7B2" },
    { key: "LWT_Y", name: "LWT Y", color: "#59A14F" },
    { key: "LWT_Z", name: "LWT Z", color: "#EDC949" },
    { key: "RH_X", name: "RH X", color: "#AF7AA1" },
    { key: "RH_Y", name: "RH Y", color: "#FF9DA7" },
    { key: "RH_Z", name: "RH Z", color: "#9C755F" },
];

// HEV 3-mount: Fr_RH / Fr_LH / Rr（infra domain/mount.py _HEV_MTG3_POINTS）
export const HEV_SERIES_3MTG: Series[] = [
    { key: "Fr_RH_X", name: "Fr RH X", color: "#1F77B4" },
    { key: "Fr_RH_Y", name: "Fr RH Y", color: "#FF7F0E" },
    { key: "Fr_RH_Z", name: "Fr RH Z", color: "#2CA02C" },
    { key: "Fr_LH_X", name: "Fr LH X", color: "#D62728" },
    { key: "Fr_LH_Y", name: "Fr LH Y", color: "#9467BD" },
    { key: "Fr_LH_Z", name: "Fr LH Z", color: "#8C564B" },
    { key: "Rr_X", name: "Rr X", color: "#17BECF" },
    { key: "Rr_Y", name: "Rr Y", color: "#BCBD22" },
    { key: "Rr_Z", name: "Rr Z", color: "#7F7F7F" },
];

export const SERIES_12: Series[] = [
    { key: "FR_LH_X", name: "FR LH X", color: "#1F77B4" },
    { key: "FR_LH_Y", name: "FR LH Y", color: "#FF7F0E" },
    { key: "FR_LH_Z", name: "FR LH Z", color: "#2CA02C" },
    { key: "FR_RH_X", name: "FR RH X", color: "#D62728" },
    { key: "FR_RH_Y", name: "FR RH Y", color: "#9467BD" },
    { key: "FR_RH_Z", name: "FR RH Z", color: "#8C564B" },
    { key: "RR_LH_X", name: "RR LH X", color: "#17BECF" },
    { key: "RR_LH_Y", name: "RR LH Y", color: "#BCBD22" },
    { key: "RR_LH_Z", name: "RR LH Z", color: "#7F7F7F" },
    { key: "RR_RH_X", name: "RR RH X", color: "#E377C2" },
    { key: "RR_RH_Y", name: "RR RH Y", color: "#FFBB78" },
    { key: "RR_RH_Z", name: "RR RH Z", color: "#393B79" },
];
